module.exports = __webpack_public_path__ + "img/logo_platinriver.d957604.png";